module.exports = __webpack_public_path__ + "./images/lab.2a7788.jpg";